module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedImage) ? _c('div', {
    staticClass: "gallery modal-gallery"
  }, [_c('div', {
    staticClass: "image-gallery"
  }, [_c('image-component', {
    attrs: {
      "src": _vm.selectedImage,
      "mouseEnter": _vm.enterOnImage,
      "mouseLeave": _vm.leaveOnImage
    }
  }), _c('gallery-zoom', {
    attrs: {
      "isDisplayed": _vm.displayZoom,
      "image": _vm.selectedImage,
      "onClick": _vm.toggleModal,
      "firstPosition": _vm.positionOnImage
    }
  })], 1), _c('div', {
    staticClass: "image-list-gallery"
  }, [_c('image-radio-list', {
    attrs: {
      "name": "gallery-list",
      "options": _vm.list,
      "defaultField": _vm.selectedIndex
    },
    on: {
      "value-changed": _vm.imageChanged
    }
  })], 1), _c('gallery-modal', {
    attrs: {
      "isDisplayed": _vm.modalDisplayed
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-image-gallery"
  }, [_c('div', {
    staticClass: "modal-image-container"
  }, [_c('image-component', {
    attrs: {
      "src": _vm.selectedImage,
      "onClick": _vm.toggleZoomModal
    }
  }), _c('zoom-in-place', {
    attrs: {
      "isDisplayed": _vm.displayZoomInModal,
      "image": _vm.selectedImage,
      "onClick": _vm.toggleZoomModal
    }
  })], 1)]), _c('div', {
    staticClass: "modal-image-list-gallery"
  }, [_c('image-radio-list', {
    attrs: {
      "name": "modal-gallery-list",
      "options": _vm.list,
      "defaultField": _vm.selectedIndex
    },
    on: {
      "value-changed": _vm.imageChanged
    }
  })], 1), _c('div', {
    staticClass: "olst-clear"
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2c956f0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/GalleryWithModal.vue
// module id = 372
// module chunks = 1